module.exports = __webpack_public_path__ + "img/line_paytable.dfbaf5ee.png";